import { api } from './client.js';

const unwrap = (resp) => resp.data?.data;

// ── Expense Management (/expenses) ────────────────────────────────────────
// Mirrors the Phase 8 frozen backend contract. Paths are relative (the axios
// client baseURL already adds the `/api` prefix). Money is integer cents.
export const expensesApi = {
  // reports
  listReports: (params) => api.get('/expenses/reports', { params }).then(unwrap),
  getReport: (id) => api.get(`/expenses/reports/${id}`).then(unwrap),
  createReport: (body) => api.post('/expenses/reports', body).then(unwrap),
  updateReport: (id, body) => api.patch(`/expenses/reports/${id}`, body).then(unwrap),
  deleteReport: (id) => api.delete(`/expenses/reports/${id}`).then(unwrap),
  checkPolicy: (id) => api.post(`/expenses/reports/${id}/check-policy`).then(unwrap),

  // lines
  addLine: (reportId, body) => api.post(`/expenses/reports/${reportId}/lines`, body).then(unwrap),
  updateLine: (id, body) => api.patch(`/expenses/lines/${id}`, body).then(unwrap),
  removeLine: (id) => api.delete(`/expenses/lines/${id}`).then(unwrap),

  // report lifecycle
  submitReport: (id) => api.post(`/expenses/reports/${id}/submit`).then(unwrap),
  approveReport: (id, body) => api.post(`/expenses/reports/${id}/approve`, body || {}).then(unwrap),
  rejectReport: (id, body) => api.post(`/expenses/reports/${id}/reject`, body || {}).then(unwrap),
  reimburseReport: (id, body) => api.post(`/expenses/reports/${id}/reimburse`, body || {}).then(unwrap),

  // policies
  listPolicies: (params) => api.get('/expenses/policies', { params }).then(unwrap),
  createPolicy: (body) => api.post('/expenses/policies', body).then(unwrap),
  updatePolicy: (id, body) => api.patch(`/expenses/policies/${id}`, body).then(unwrap),
  deletePolicy: (id) => api.delete(`/expenses/policies/${id}`).then(unwrap),

  // mileage rates
  listMileageRates: (params) => api.get('/expenses/mileage-rates', { params }).then(unwrap),
  createMileageRate: (body) => api.post('/expenses/mileage-rates', body).then(unwrap),

  // corporate cards
  listCards: (params) => api.get('/expenses/cards', { params }).then(unwrap),
  createCard: (body) => api.post('/expenses/cards', body).then(unwrap),

  // card transactions
  listCardTransactions: (params) => api.get('/expenses/card-transactions', { params }).then(unwrap),
  importCardTransactions: (body) => api.post('/expenses/card-transactions/import', body).then(unwrap),
  matchCardTransaction: (id, body) => api.post(`/expenses/card-transactions/${id}/match`, body).then(unwrap),
  ignoreCardTransaction: (id) => api.post(`/expenses/card-transactions/${id}/ignore`).then(unwrap),
};

// Format integer cents to a display string (cents/100, 2 decimals).
export function formatCents(cents, currency = '') {
  const n = Number(cents || 0) / 100;
  return `${currency} ${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`.trim();
}
